import { Box } from "@mui/material";
import { useEffect } from "react";

const AdBlockComponent = (props) => {
  const { isMobile } = props.state;
  const { adSlot } = props;
  const isLocalhost = window.location.hostname === "localhost";

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdBlock error:", e);
    }
  }, []);

  const normalStyling = {
    width: "100%",
    maxWidth: "960px",
    margin: isMobile ? "8px auto 16px" : "16px auto",
    backgroundColor: "rgba(0,0,0,0.1)",
    borderRadius: 8,
    minHeight: isMobile ? "140px" : "250px",
  };


  if (isLocalhost) return null;

  return (
    <Box id="adBlockDisplay" sx={normalStyling}>
      <ins
        key={adSlot}
        className="adsbygoogle"
        style={{ display: "block", width: "100%" }}
        data-ad-client="ca-pub-2445506326822662"
        data-ad-slot={adSlot}
        data-ad-format="rectangle"
        data-ad-layout="in-article"
      ></ins>
    </Box>
  );
};

export default AdBlockComponent;
